import { render, staticRenderFns } from "./BDSelectCompanyModal.vue?vue&type=template&id=60d6a5ec&"
import script from "./BDSelectCompanyModal.vue?vue&type=script&lang=js&"
export * from "./BDSelectCompanyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports